<div class="ipm-download-container">
    <div class="ipm-heading-model-section">
        <h3></h3>
        <div class="ipm-close-icon" (click)="close()">
            <i class="pi pi-times"></i>
        </div>
    </div>
    <div class="ipm-download-pop-body">
        <div class="ipm-main-section">
            <div class="ipm-image-section">
                    <img priority [src]="producerData?.currentBeatData?.producer?.store?.brand?.picture" class="ipm-img-cover"
                    (error)="browserStorageService.errorHandler($event, 'user')" [class.p-4]="!producerData?.currentBeatData?.producer?.store?.brand?.picture"
                    [class.not-setImage]="!producerData?.currentBeatData?.producer?.store?.brand?.picture"
                    alt="user-image" loading="lazy" width="130px" height="130px">
            </div>
            <div class="ipm-artist-details-section">
                <h3 >{{producerData?.currentBeatData?.producer?.store?.general?.name}}</h3>
                <p>  {{producerData?.currentBeatData?.producer?.store?.brand?.summary}}</p>
                <div class="ipm-social-follows position-relative">
                    <div class="follow-section">
                        <span class="text">
                                <img alt="user icon" priority src="./assets/imgs/sub-menu/user-check-icon.png">
                        </span>
                        <span class="count">{{commonFuncService.nFormatter(producerData?.followCount, 1) }}</span>
                    </div>
                    <div class="follow-section">
                        <span class="text">
                            <img alt="user icon" priority src="./assets/imgs/sub-menu/play-icon-download.png">
                        </span>
                        <span class="count">{{commonFuncService.nFormatter(producerData?.playCountCount, 1) }}</span>
                    </div>
                    <div class="follow-section">
                        <span class="text">
                            <img alt="user icon" priority src="./assets/imgs/sub-menu/music-track-icon.png">
                        </span>
                        <span class="count">{{commonFuncService.nFormatter(producerData?.trackCount, 1) }}</span>
                    </div>
                    <div class="follow-section mobile-view-download ">
                        <span class="text text-center"><i class="pi pi-cloud-download"></i> <i class="fas fa-info-circle info-icon "
                            matTooltip="You can download {{downloadTotalQuota}} MP3s based on your default monthly quota."></i></span>
                        <span class="count">{{commonFuncService.nFormatter(downloadLeft, 1) }} </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="py-2" >
        <div class="info" *ngIf="producerData?.currentUser?.role === 'customer'">
            <p *ngIf="!producerData?.currentUser.mobile?.isVerified">
                <i class="fas fa-info-circle info-icon mr-3 ml-0" ></i> Get 20 more free downloads by completing your <a (click)="goToProfile()">profile</a>
            </p>
        </div>
        <div class="checkout-flow" *ngIf="downloadLeft > 0" >
            <mat-checkbox
                [(ngModel)]="isAcceptTermCondition"
                required
                (ngModelChange)="onChangeCheckBox($event)">
                I hereby acknowledge and agree that the MP3 music being made available for free download and unlimited use, will only be used for non-commercial purposes such as personal use and/or sharing on social media.
            </mat-checkbox>
        </div>
    </div>
    <div class="ipm-actions">
        <button class="btn ipm-submit-btn" [class.profile-button-color]="producerData?.currentUser?.role === 'customer' && !producerData?.currentUser.mobile?.isVerified && downloadLeft === 0"
            (click)="callingApi()"
            [disabled]="isButtonIsDisable">
            {{buttonText}}
        </button>
        <!-- <button class="btn profile-button-color"  (click)="callingApi()" [disabled]="!isAcceptTermCondition || downloadLeft === 0"> Complete your profile </button> -->
    </div>
</div>
